<template>
  <modal ref="modalEditarItem" :id="'modal-editar-item'" :titulo="$t('CONTABIL.EDITAR_ITEM')" tamanho="xl"
    :ocultarRodape="true" class="d-flex align-items-center justify-content-center" dialog-class="modal-dialog-centered">
    <b-form @submit.prevent="salvar" class="w-100">
      <div class="row">

        <div class="col-md-3">
          <b-form-group label="Tipo de Movimento*" label-for="tipoMovimento" :state="validarCampo(form.tipoMovimento)"
            invalid-feedback="Campo obrigatório">
            <b-form-select id="tipoMovimento" v-model="form.tipoMovimento" :options="opcoes.tiposMovimento"
              :state="validarCampo(form.tipoMovimento)" />
          </b-form-group>
        </div>

        <div class="col-md-3">
          <b-form-group label="Valor*" label-for="valor" :state="validarCampo(form.valor)"
            invalid-feedback="Campo obrigatório">
            <b-form-input id="valor" type="number" step="0.01" v-model="form.valor" :state="validarCampo(form.valor)" />
          </b-form-group>
        </div>

        <div class="col-md-6">
          <input-select-search ref="planoConta" v-model="form.planoConta" :label="$t(`CONTABIL.PLANO_CONTA`)"
            :options="opcoes.planosConta" :limparValidacao="resetarValidacao" required />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <b-form-group label="Descrição do lançamento*" label-for="descricao" :state="validarCampo(form.descricao)"
            invalid-feedback="Campo obrigatório">
            <b-form-textarea id="descricao" v-model="form.descricao" :state="validarCampo(form.descricao)" rows="4"
              max-rows="6" placeholder="Digite a descrição..." />
          </b-form-group>
        </div>
      </div>

      <div class="d-flex justify-content-between">
        <b-button variant="secondary" @click="fechar">Cancelar</b-button>
        <b-button variant="primary" @click="salvar">Salvar</b-button>
      </div>
    </b-form>
  </modal>
</template>

<script>
import Modal from '@/components/modal/Modal.vue';
import PlanoContaService from '@/common/services/plano-conta/plano-conta.service.js';
import { InputSelectSearch } from '@/components/inputs';


export default {
  name: 'ModalEditarDocumentoItem',
  components: { Modal, InputSelectSearch },
  props: {
    resetarValidacao: { type: Boolean, default: false },
    item: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      form: {
        tipoMovimento: '',
        valor: null,
        descricao: '',
        planoConta: '',
      },
      opcoes: {
        tiposMovimento: [
          { value: 'Crédito', text: 'Crédito' },
          { value: 'Débito', text: 'Débito' },
        ],
        planosConta: [],
      },
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(novo) {
        if (novo && this.opcoes.planosConta.length) {
          const planoSelecionado = this.opcoes.planosConta.find(
            p => p.text === novo.contaContabilCompleto
          );
          this.form = {
            tipoMovimento: novo.tipoMovimentoDescricao || '',
            valor: novo.valor || null,
            descricao: novo.descricao || '',
            planoConta: planoSelecionado ? planoSelecionado.value : '',
          };
        } else if (novo) {
          this.form.tipoMovimento = novo.tipoMovimentoDescricao || '';
          this.form.valor = novo.valor || null;
          this.form.descricao = novo.descricao || '';
          this.form.planoConta = '';
        } else {
          this.form = {
            tipoMovimento: '',
            valor: null,
            descricao: '',
            planoConta: '',
          };
        }
      },
    },
  },
  mounted() {
    this.carregarPlanosConta();
  },
  methods: {
    carregarPlanosConta() {
      PlanoContaService.obterTodos()
        .then(({ data }) => {
          this.opcoes.planosConta = data.map(row => ({
            // mantenha value para o v-model do seu InputSelectSearch
            value: row.id ?? row.planoContaId ?? row.codigoPlano ?? row.codigo,
            text: `${row.codigo} - ${row.descricao}`,
            // metadados necessários pro payload
            id: row.id ?? row.planoContaId ?? row.codigoPlano ?? row.codigo,
            codigo: row.codigo,
            descricao: row.descricao,
          }));

          if (this.item && this.item.contaContabilCompleto) {
            const planoSelecionado = this.opcoes.planosConta.find(
              p => p.text === this.item.contaContabilCompleto
            );
            this.form.planoConta = planoSelecionado ? planoSelecionado.value : '';
          }
        })
        .catch(err => console.error('Erro ao carregar planos de conta:', err));
    },
    abrir() {
      this.$refs.modalEditarItem.show();
    },
    fechar() {
      this.$refs.modalEditarItem.hide();
    },
    validarCampo(campo) {
      return campo !== null && campo !== '';
    },
    salvar() {
      if (
        !this.validarCampo(this.form.tipoMovimento) ||
        !this.validarCampo(this.form.valor) ||
        !this.validarCampo(this.form.descricao) ||
        !this.validarCampo(this.form.planoConta)
      ) {
        return;
      }

      // 1) resolver o plano selecionado (suporta v-model como value ou como objeto)
      let selectedPlano = null;

      if (this.form.planoConta && typeof this.form.planoConta === 'object') {
        // seu InputSelectSearch devolveu o objeto
        const v = this.form.planoConta;
        selectedPlano = {
          id: v.id ?? v.value,
          codigo: v.codigo,
          descricao: v.descricao,
          text: v.text ?? `${v.codigo} - ${v.descricao}`,
        };
      } else {
        // devolveu apenas o value (id/código); buscamos nas opções
        selectedPlano = this.opcoes.planosConta.find(p => p.value === this.form.planoConta);
      }

      // fallback seguro
      const planoId = selectedPlano?.id ?? this.form.planoConta;
      const planoCodigo = selectedPlano?.codigo ?? this.item?.planoContaCodigo;
      const planoText = selectedPlano?.text ?? this.item?.contaContabilCompleto;

      // 2) mapear tipoMovimento para id
      const tmDesc = this.form.tipoMovimento; // 'Crédito' ou 'Débito'
      const tmId = tmDesc === 'Crédito' ? 99 : 98;

      // 3) montar objeto completo e consistente
      const itemAtualizado = {
        tipoMovimento: tmId,                         // <-- id numérico (98/99)
        tipoMovimentoDescricao: tmDesc,              // <-- descrição
        valor: Number(this.form.valor),
        descricao: this.form.descricao,

        planoContaId: planoId,                       // <-- imprescindível pro back
        planoContaCodigo: planoCodigo ?? null,       // opcional, mas mantém consistência
        contaContabilCompleto: planoText ?? '',      // "codigo - descricao"
      };

      this.$emit('atualizar-item', itemAtualizado);
      this.fechar();
    }
  },
};
</script>
